<template>
  <div class="manage-resource">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Danh sách Awards & Achievements</h6>
          <router-link :to="{ name: 'CreateAwardsArchievements' }">
            <a-button type="primary" class="ml-20">Thêm mới</a-button>
          </router-link>
        </a-row>
      </template>
      <a-table
        :columns="columns"
        :loading="callingAPI"
        :data-source="dataSource"
        :pagination="{
          pageSize: per_page,
          total: total,
          defaultCurrent: page
        }"
        @change="handleChangePage"
        rowKey="id"
      >
        <template slot="award_date" slot-scope="row">
          <span v-if="row">{{ row | formatDate }}</span>
        </template>
        <template slot="active" slot-scope="row">
          <a-switch
            v-model="row.active"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
        <template slot="action" slot-scope="row">
          <a-space>
            <router-link
              :to="{ name: 'UpdateAwardsArchievements', params: { id: row.id } }"
            >
              <a-button shape="circle" icon="edit" size="small" />
            </router-link>
            <a-popconfirm
              placement="topRight"
              ok-text="Xóa"
              cancel-text="Hủy"
              @confirm="remove(row)"
            >
              <template slot="title">
                <p>Xóa partner {{ row.title }} ??</p>
              </template>
              <a-button
                type="danger"
                shape="circle"
                icon="delete"
                size="small"
              />
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {fetchAwards, updateAwards, remove} from '@/services/landing-page/about-us'
import dayjs from 'dayjs'
  export default {
    name: 'ManageAwards',
    data() {
      return {
        callingAPI: true,
        dataSource: [],
        columns: [
          {
            title: 'Tiêu đề',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title' },
            class: 'font-semibold',
            width: '150px'
          },
          {
            title: 'Nội dung',
            dataIndex: 'content',
            class: 'font-semibold',
          },
          {
            title: 'Ngày nhận',
            dataIndex: 'award_date',
            scopedSlots: { customRender: 'award_date' },
            width: '150px'
          },
          {
            title: 'Hiển thị',
            scopedSlots: { customRender: 'active' },
            width: '100px',
            fixed: "right",
          },
          {
            title: '',
            scopedSlots: { customRender: 'action' },
            width: '50px',
            fixed: "right",
          },
        ],
        type: 2,
        post_type: 2,

        // Pagination
        per_page: 10,
        page: 1,
        total: 0
      }
    },
    async beforeMount() {
      await this.loadData()
    },
    methods: {
      async handleChangePage(data) {
        this.page = data.current
        await this.loadData()
      },

      async loadData(loading = true) {
        try {
          this.callingAPI = loading
          const params = {
            type: this.type,
            post_type: this.post_type,
            per_page: this.per_page,
            page: this.page
          }
          const response = await fetchAwards(params)
          this.dataSource = response.data.data.map((d) =>({
            ...d,
            active: d.active === 1,
            loadingActive: false
          }))
          this.total = response.data.total
          this.callingAPI = false
        } catch (error) {}
      },

      async handleUpdate(row) {
        const index = this.dataSource.findIndex((r) => r.id === row.id)
        this.dataSource[index].loadingActive = true
        try {
          const data = {
            ...row,
            award_date: dayjs(row.award_date).format('DD/MM/YYYY'),
            active: row.active ? 1 : 2,
            _method: 'PUT'
          }
          delete data.loadingActive
          delete data.updated_at
          delete data.created_at

          const response = await updateAwards(row.id, data)
          this.dataSource[index].loadingActive = false
          if (response.status === 1) {
            this.$notification.success({
              message: 'Thành công',
              description: 'Cập nhật trạng thái hiển thị thành công.',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Cập nhật trạng thái hiển thị thất bại.',
            });
          }
        } catch (error) {
          this.dataSource[index].loadingActive = false
          this.$notification.error({
            message: 'Thất bại',
            description: 'Cập nhật trạng thái hiển thị thất bại.',
          });
        }
      },

      async remove(row) {
        try {
          this.callingAPI = true
          const response = await remove(row.id)
          if (response.status === 1) {
            this.page = 1
            await this.loadData()
            this.$notification.success({
              message: 'Thành công',
              description: 'Xóa thành công',
            });
          } else {
            this.$notification.error({
              message: 'Thất bại',
              description: 'Xóa thất bại',
            });
          }
          this.callingAPI = false
        } catch (error) {
          this.callingAPI = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>